import { View } from 'react-native';

import { Text } from '@/components/ui/Text';

import { AfterSealBadge } from './AfterSealBadge';

export interface NoteEntryData {
  id: string;
  author: string;
  time: string;
  body: string;
  /** The note reached the server after the run was sealed — see `AfterSealBadge`. */
  late?: boolean;
}

/** A single attributed, immutable log note. */
export function NoteEntry({ author, time, body, late }: Omit<NoteEntryData, 'id'>) {
  return (
    <View>
      <View className="flex-row items-center gap-2">
        <Text variant="caption">
          <Text variant="none" className="font-sans-semibold text-sm text-foreground">
            {author}
          </Text>
          {`  ·  ${time}`}
        </Text>
        {late ? <AfterSealBadge /> : null}
      </View>
      <Text variant="body" className="mt-0.5 text-[15px]">
        {body}
      </Text>
    </View>
  );
}
